/**
 * Registration feature strings.
 *
 * Namespace: registration
 */
export const registration = {
  // Page
  page: {
    title: "Fiók létrehozása",
    subtitle: "Adja meg az adatait a regisztrációhoz",
    hasAccount: "Már van fiókja?",
    signIn: "Jelentkezzen be",
  },

  // Form fields
  form: {
    firstNameLabel: "Keresztnév",
    firstNamePlaceholder: "János",
    lastNameLabel: "Vezetéknév",
    lastNamePlaceholder: "Kovács",
    emailLabel: "E-mail cím",
    emailPlaceholder: "példa@example.com",
    passwordLabel: "Jelszó",
    passwordPlaceholder: "••••••••",
    passwordHelperText: "Legalább 8 karakter",
    confirmPasswordLabel: "Jelszó megerősítése",
    confirmPasswordPlaceholder: "••••••••",
    passwordGroupLabel: "Jelszó beállítása",
    organizationLabel: "Szervezet neve",
    organizationPlaceholder: "Szervezet Kft.",
    organizationHelperText: "Adja meg a szervezete nevét",
    accountTypeLabel: "Fiók típusa",
    isIndividualLabel: "Egyéni regisztráció (nem szervezet nevében)",
    legalGroupLabel: "Jogi nyilatkozatok elfogadása",
    acceptPrivacyPolicy: "Elfogadom az",
    privacyPolicyLink: "Adatvédelmi szabályzatot",
    acceptTermsOfService: "Elfogadom a",
    termsOfServiceLink: "Felelősségi nyilatkozatot",
    submitButton: "Fiók létrehozása",
  },

  // Errors (backend error code mapping)
  errors: {
    emailNotUnique: "A megadott e-mail cím már használatban van",
    recaptchaFailed: "reCAPTCHA ellenőrzés sikertelen. Kérjük, próbálja újra.",
  },

  // Rate limit
  rateLimit: {
    title: "Túl sok kísérlet",
    message: "Kérjük, próbálja újra néhány perc múlva.",
  },

  // Success
  success: {
    title: "Fiók létrehozva!",
    message: "Kérjük, ellenőrizze az e-mail fiókját a megerősítéshez.",
    goToLogin: "Tovább a bejelentkezéshez",
  },
} as const;
